import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useAuth } from "../../hooks/useAuth";
import { loginRequest } from "../../config/authConfig";

export function useProfilePhoto() {
  const { instance, accounts } = useMsal();
  const { user } = useAuth();
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    if (!user) return;
    const account = instance.getActiveAccount() || accounts[0];
    if (!account) return;

    let objectUrl;

    const fetchPhoto = async () => {
      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account,
        });

        const res = await fetch(
          "https://graph.microsoft.com/v1.0/me/photo/$value",
          {
            headers: {
              Authorization: `Bearer ${response.accessToken}`,
            },
          }
        );

        if (!res.ok) return;

        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);
        setPhoto(objectUrl);
      } catch (err) {
        if (err instanceof InteractionRequiredAuthError) {
          console.warn("User interaction required to fetch photo");
        } else {
          console.error("Failed to fetch profile photo:", err);
        }
      }
    };

    fetchPhoto();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [accounts, instance, user]);

  return photo;
}
